import React from 'react';
import * as Tools from "../../helpers/Tools";
import {
    PROXY_APPROVED, PROXY_PENDING, PROXY_CANCELLED, EPIC, RX, RXEPIC, REQUEST, REQUESTV2, GRANT, ACCEPT, DECLINE,
    EPIC_GRANT_ADULT_FEATUREID, EPIC_GRANT_MINOR_FEATUREID, RX_GRANT_ADULT_FEATUREID, RX_GRANT_MINOR_FEATUREID, RX_EPIC_GRANT_ADULT_FEATUREID, RX_EPIC_GRANT_MINOR_FEATUREID,
    EPIC_REQUEST_ADULT_FEATUREID, EPIC_REQUEST_MINOR_FEATUREID, RX_REQUEST_ADULT_FEATUREID, RX_REQUEST_MINOR_FEATUREID, RX_EPIC_REQUEST_ADULT_FEATUREID,
    EPIC_GRANT_ACCEPT_ADULT_FEATUREID, RX_GRANT_ACCEPT_ADULT_FEATUREID, RX_EPIC_GRANT_ACCEPT_ADULT_FEATUREID, EPIC_REQUEST_ACCEPT_ADULT_FEATUREID, RX_REQUEST_ACCEPT_ADULT_FEATUREID,
    RX_EPIC_REQUEST_ACCEPT_ADULT_FEATUREID, RX_EPIC_REQUEST_MINOR_FEATUREID, INITIATE_REQUEST_ACEEPT_GRANT_FEATUREID, INITIATE_GRANT_APPROVE_REQUEST_FEATUREID, ONBOARDING_FLOW
} from "../../constants/textConstants";

//import * as sanitizeHtml from "sanitize-html-react";
import sanitizeHtml from 'sanitize-html-react';

export const getProxySource = (healthrecord, pharmacy) => {
    return healthrecord && pharmacy ? RXEPIC : pharmacy ? RX : EPIC;
};

//This is meant for  logging only.
export const getLogProxySource = (proxySource) => {
    const source = proxySource.toLowerCase();
    return source === RXEPIC ? "RxAndEpic" : source === RX ? "Rx" : source === EPIC ? "Epic" : "";
};

//This is meant for  logging only.
export const getLogRequestType = (requestType) => {
    return requestType.toLowerCase() === GRANT ? "Grant" : (requestType.toLowerCase() === REQUEST ? "Request" : (requestType.toLowerCase() === REQUESTV2 ? "Request.V2" : ""));
};

//This is meant for onboarding layout logging only
export const getLogLayoutStatus = (useOnboardingLayout) => {
    return useOnboardingLayout ? ".OnboardingFlow" : "";
}

export const getProxySuggestions = (proxySuggestionUserCount) => {
    return proxySuggestionUserCount ? ".ProxySuggestionsFlow" : "";
}
export const getProxyActiveUser = (user,count) => {
    return user && count ? `.${user}` : "";
}

export const getFeatureId = (requestType, proxySource, age, action) => {
    let isMinor = age !== null && age < 18; //age = null;
    let featureId = null;
    if (requestType === GRANT && proxySource) {
        switch (proxySource) {
            case EPIC:
                featureId = isMinor ? EPIC_GRANT_MINOR_FEATUREID : action === ACCEPT ? INITIATE_REQUEST_ACEEPT_GRANT_FEATUREID : INITIATE_GRANT_APPROVE_REQUEST_FEATUREID;
                break;
            case RX:
                featureId = isMinor ? RX_GRANT_MINOR_FEATUREID : action === ACCEPT ? INITIATE_REQUEST_ACEEPT_GRANT_FEATUREID : INITIATE_GRANT_APPROVE_REQUEST_FEATUREID;
                break;
            case RXEPIC:
                featureId = isMinor ? RX_EPIC_GRANT_MINOR_FEATUREID : action === ACCEPT ? INITIATE_REQUEST_ACEEPT_GRANT_FEATUREID : INITIATE_GRANT_APPROVE_REQUEST_FEATUREID;
                break;
            default:
                featureId = null;
        }
    }
    else if ((requestType === REQUEST || requestType=== REQUESTV2) && proxySource) {
        switch (proxySource) {
            case EPIC:
                featureId = isMinor ? RX_EPIC_REQUEST_MINOR_FEATUREID : action === ACCEPT ? INITIATE_GRANT_APPROVE_REQUEST_FEATUREID : INITIATE_REQUEST_ACEEPT_GRANT_FEATUREID;
                break;
            case RX:
                featureId = isMinor ? RX_EPIC_REQUEST_MINOR_FEATUREID : action === ACCEPT ? INITIATE_GRANT_APPROVE_REQUEST_FEATUREID : INITIATE_REQUEST_ACEEPT_GRANT_FEATUREID;
                break;
            case RXEPIC:
                featureId = isMinor ? RX_EPIC_REQUEST_MINOR_FEATUREID : action === ACCEPT ? INITIATE_GRANT_APPROVE_REQUEST_FEATUREID : INITIATE_REQUEST_ACEEPT_GRANT_FEATUREID;
                break;
            default:
                featureId = null;
        }
    }
    return featureId;
};

export const sanitizeContent = (content) => {
    let allowedTagsList = ['p', 'ul', 'li'];
    let allowedAttributesList = {        
        'ul': ['class']
    };
    var santitizedContent = sanitizeHtml(content, {
        allowedTags: allowedTagsList,
        allowedAttributes: allowedAttributesList
    });
    return santitizedContent;
};

